import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;
  expireTime: any;
  time: string;
  expireTimeOut: any;
  walletAmount: any;
  userDetails: any;
  currentUserDetails: any;
  userType: any;
  navshoe: boolean = false;
  public innerWidth: any;
  uniqueId: any;
  isSpin: boolean=false;
  retailorParentDistributorUniqueName: any;
  getRetailerNotificationsCount: any;
  alertMessage: any="";
  constructor(private authService: AuthService, private router: Router) {
    this.authService.rechagehappenfromwallet$.subscribe((data) => {
      if (data == 'transhappened') {
        this.fetchWalletBalance();
      }
    });
    this.retailorParentDistributorUniqueName= localStorage.getItem('retailorParentDistributorUniqueName');
  }
  currentUserDetails2:any
  ngOnInit() {

    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1000) {
      this.navshoe = false;
      this.authService.sideNav(this.navshoe);
    }

    this.userType = localStorage.getItem('userType');
    this.currentUserDetails = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUserDetails2 = localStorage.getItem('retailorName');

    this.uniqueId = localStorage.getItem('uniqueName');
    this.isLoggedIn$ = this.authService.isLoggedIn;
    if (localStorage.getItem('currentUser')) {
      this.userDetails = JSON.parse(localStorage.getItem('currentUser')).data;
      this.expireTime = this.userDetails['expiryTime'];
      this.expireTimeOut = setInterval(() => {
        let _due_date = new Date(this.expireTime);
        let _currebt_date = new Date().getTime();
        this.time = this.diffDT(_currebt_date, _due_date);
        // var timenew= 
        // tslint:disable-next-line: max-line-length
        const compleateExpireTime = _due_date.getDay() + '-' + _due_date.getMonth() + '-' + _due_date.getFullYear() + ':' + _due_date.getHours() + '-' + _due_date.getMinutes() + '-' + _due_date.getSeconds();
        // tslint:disable-next-line: max-line-length
        const currentExpireTime = new Date().getDay() + '-' + new Date().getMonth() + '-' + new Date().getFullYear() + ':' + new Date().getHours() + '-' + new Date().getMinutes() + '-' + new Date().getSeconds();
        if (compleateExpireTime == currentExpireTime) {
          alert('your session is expired::');
          localStorage.clear();
          this.router.navigate(['/login']);
        }

      }, 1000);
    }
    
    this.fetchWalletBalance();
    this.getRetailerNotificationsCount=localStorage.getItem('notfications');
    this.getRetailerNotifications();
  }

  getRetailerNotifications(){
    this.authService.getRetailerNotificationsApi('NOTIFICATION').subscribe((res:any)=>{
      if(res.status_code == 1){
        this.getRetailerNotificationsCount = res.object.length;
      }else {
        this.getRetailerNotificationsCount = "";
      }
    },err=>{
    })
    this.authService.getRetailerNotificationsApi('ALERT').subscribe((res:any)=>{
      if(res.status_code == 1){
        for (var i=0;i<res.object.length;i++){
          this.alertMessage = this.alertMessage + " *** " +res.object[i].message;

        }
      }else {
        this.alertMessage = "";
      }
    },err=>{
    })
  }
  
  fetchWalletBalance() {
    this.authService.getRetailerWalletBalance().subscribe(res=>{
      this.walletAmount = res;
      
    });
  }

  updateWallet() {
    this.fetchWalletBalance();
  }
  diffDT(startDate, endDate): string {
    var sec_num = (endDate - startDate) / 1000;
    var days = Math.floor(sec_num / (3600 * 24));
    var hours = Math.floor((sec_num - days * (3600 * 24)) / 3600);
    var minutes = Math.floor(
      (sec_num - days * (3600 * 24) - hours * 3600) / 60
    );
    var seconds = Math.floor(
      sec_num - days * (3600 * 24) - hours * 3600 - minutes * 60
    );

    if (hours < 10) {
      hours = hours;
    }
    if (minutes < 10) {
      minutes = minutes;
    }
    if (seconds < 10) {
      seconds = seconds;
    }

    return (
      // days +
      // ' days :' +
      hours +
      ' hours :' +
      minutes +
      ' minutes :' +
      seconds +
      ' seconds'
    );
  }
  onLogout() {
      // this.authService.logout().subscribe((logoutdata: any) => {
      //   if (logoutdata.status_code == 200) {
      //     localStorage.clear();
      //     this.router.navigate(['/login']);
      //   }
      // });
      this.authService.logout2().subscribe((logoutdata: any) => {
        if (logoutdata.status_code == 1) {
          localStorage.clear();
          this.router.navigate(['/login']);
        }
      });
  }

  sideNev() {
    if (this.navshoe == false) {
      this.navshoe = true;
      this.authService.sideNav(this.navshoe);
    } else {
      this.navshoe = false;
      this.authService.sideNav(this.navshoe);
    }
  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngOnDestroy() {
    if (this.expireTimeOut) {
      clearInterval(this.expireTimeOut);
    }
  }
}
